import l10n from '../../shared/strings';

const WARNING_MESSAGES = {
  IMPORT_SAVED_SEARCH_FAILED: l10n.TOAST.BATCH_IMPORT_SAVED_SEARCH_FAILED,
};

/**
 * Maps server batch-import warning.code to user-facing copy.
 * @param {{ code?: string }|null|undefined} warning
 * @returns {string|null}
 */
export default function getBatchImportWarningMessage(warning) {
  if (!warning?.code) {
    return null;
  }

  return WARNING_MESSAGES[warning.code] || null;
}
